// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M9 4.5V13L15 8L21 13V21H3V4.5L6 2L9 4.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M17 15H13V21H17V15Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M17 15H13V21H17V15Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9 13V21M9 13V4.5L6 2L3 4.5V21H9M9 13L15 8L21 13V21H9M9 21C9.70578 21 8.36845 21 9 21Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city-2')
export default class City2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-2',
    }
  }
}
